import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import classNames from 'classnames';

import {
  BusinessOfferContainer,
} from '../../containers/BusinessOfferContainer/BusinessOfferContainer';
import { FormLocationDataLayer } from '../../hooks/dataLayerHooks/dataLayerV2Hooks';
import { Animations, Modal } from '../Modal/Modal';
import { PdpUsps } from '../PdpUsps/PdpUsps';
import { Title } from '../Title/Title';
import styles from './BusinessPDPModalForm.module.css';

const messages = defineMessages({
  modalTitle: {
    id: 'src.components.BusinessPDPModalForm.modalTitle',
    defaultMessage: 'Request a no-obligation quote!',
  },
});

export type Props = {
  isDesktop: boolean;
  isMobileLayout: boolean;
  isOpen: boolean;
  isPDPBusinessModalUsps: boolean;
  onClose: () => void;
};

export const BusinessPDPModalForm = React.memo((props: Props) => {
  const {
    isDesktop,
    isMobileLayout,
    isOpen,
    onClose,
    isPDPBusinessModalUsps,
  } = props;

  return (
    <Modal
      shouldCloseOnEsc
      isMobileLayout={isMobileLayout}
      isOpen={isOpen}
      onClose={onClose}
      animation={{
        desktop: Animations.opacity,
        mobile: Animations.fromDownToTop,
      }}
      modalContentWrapperClassName={{ base: styles.modalContentWrapper }}
      modalContentClassName={styles.modalContent}
      closeBtnColor='var(--light-grey)'
      header={
        <div className={classNames(styles.modalHeader, {
          [styles.withUsps]: isPDPBusinessModalUsps && isDesktop,
        })}>
          <Title
            variant='h4'
            title={<FormattedMessage {...messages.modalTitle} />}
          />
          {isPDPBusinessModalUsps && isDesktop && <PdpUsps />}
        </div>
      }
    >
      <BusinessOfferContainer
        offerBlockTitle={null}
        offerBlockSubtitle={null}
        onCloseCallback={onClose}
        isTwoColumnsLayout
        formLocation={FormLocationDataLayer.pdpBusinessButton}
      />
    </Modal>
  );
});

BusinessPDPModalForm.displayName = 'BusinessPDPModalForm';
